"use client";

import { createContext, type PropsWithChildren, useContext } from "react";
import type { StoriesRoute } from "@/data/routes/stories.route";

interface HeaderContext {
	content: NonNullable<StoriesRoute["header"]>["content"];
}

const HeaderContext = createContext<HeaderContext>(null!);

export const HeaderProvider = ({ children, content }: PropsWithChildren<HeaderContext>) => {
	return <HeaderContext.Provider value={{ content }}>{children}</HeaderContext.Provider>;
};

export const useHeader = () => {
	const ctx = useContext(HeaderContext);

	if (!ctx) {
		throw new Error("useContenxt must be used within a HeaderProvider!");
	}

	return ctx;
};
